module.exports = __webpack_public_path__ + "static/elebute-029a444c73908453f90fe73291986a32.png";